/**
 * 新版旺旺表情，数组标识展示顺序
 *
 */
export const WW_SMILEY = [
  ['001', '微笑'    ],
  ['002', '害羞'    ],
  ['003', '吐舌头'  ],
  ['047', '忧伤'    ],
  ['024', '再见'    ],
  ['030', '迷惑'    ],
  ['009', '安慰'    ],
  ['008', '飞吻'    ],
  ['023', '天使'    ],
  ['054', '挥泪告别'],
  ['005', '爱慕'    ],
  ['011', '加油'    ],
  ['040', '傻笑'    ],
  ['036', '小样'    ],
  ['048', '委屈'    ],
  ['049', '悲泣'    ],
  ['050', '大哭'    ],
  ['051', '痛哭'    ],
  ['053', '对不起'  ],
  ['070', '小二'    ],
  ['069', '恭喜发财'],
  ['067', '财神'    ],
  ['010', '抱抱'    ],
  ['085', '玫瑰'    ],
  ['087', '爱心'    ],
  ['078', '漂亮MM'  ],
  ['079', '帅哥'    ],
  ['012', '胜利'    ],
  ['081', '成交'    ],
  ['082', '鼓掌'    ],
  ['083', '握手'    ],
  ['031', '疑问'    ],
  ['042', '无奈'    ],
  ['013', '强'      ],
  ['007', '跳舞'    ],
  ['017', '查找'    ],
  ['026', '享受'    ],
  ['004', '偷笑'    ],
  ['021', '好主意'  ],
  ['025', '流口水'  ],
  ['016', '露齿笑'  ],
  ['043', '流汗'    ],
  ['028', '呆若木鸡'],
  ['055', '皱眉'    ],
  ['037', '摇头'    ],
  ['019', '算账'    ],
  ['014', '亲亲'    ],
  ['015', '花痴'    ],
  ['018', '呼叫'    ],
  ['029', '思考'    ],
  ['006', '大笑'    ],
  ['035', '嘘'      ],
  ['060', '惊讶'    ],
  ['061', '惊愕'    ],
  ['066', '生气'    ],
  ['071', '老大'    ],
  ['068', '学习雷锋'],
  ['088', '心碎'    ],
  ['080', '招财猫'  ],
  ['084', '红唇'    ],
  ['094', '举杯庆祝'],
  ['089', '钱'      ],
  ['097', '很晚了'  ],
  ['091', '礼物'    ],
  ['090', '购物'    ],
  ['096', '等待'    ],
  ['095', '时钟'    ]
]

// 小二不可使用的表情
export const WW_BLACKLIST = [
  ['020', '财迷'    ],
  ['022', '鬼脸'    ],
  ['027', '色情狂'  ],
  ['032', '没钱了'  ],
  ['033', '无聊'    ],
  ['034', '怀疑'    ],
  ['038', '感冒'    ],
  ['039', '尴尬'    ],
  ['041', '不会吧'  ],
  ['044', '凄凉'    ],
  ['045', '困了'    ],
  ['046', '晕'      ],
  ['052', 'I服了U'  ],
  ['056', '好累'    ],
  ['058', '吐'      ],
  ['059', '背'      ],
  ['062', '闭嘴'    ],
  ['063', '欠扁'    ],
  ['064', '鄙视你'  ],
  ['065', '大怒'    ],
  ['072', '邪恶'    ],
  ['073', '单挑'    ],
  ['074', 'CS'      ],
  ['075', '隐形人'  ],
  ['076', '炸弹'    ],
  ['077', '惊声尖叫'],
  ['086', '残花'    ],
  ['092', '收邮件'  ],
  ['093', '电话'    ],
  ['098', '飞机'    ],
  ['099', '支付宝'  ]
]

/**
 * 小蜜表情，数组标识展示顺序
 *
 */
export const XM_SMILEY = [
  ['001', '打招呼'],
  ['002', '唱歌'  ],
  ['003', '打屁屁'],
  ['006', '开心'  ],
  ['007', '可怜'  ],
  ['010', '么么哒'],
  ['011', '帅'    ],
  ['012', '送花'  ],
  ['013', '微笑'  ],
  ['014', '委屈'  ],
  ['016', '再见'  ],
  ['017', 'OK'    ]
]

// 小二不可使用的表情
export const XM_BLACKLIST = [
  ['004', '愤怒'],
  ['005', '惊吓'],
  ['008', '抠鼻'],
  ['009', '冷漠'],
  ['015', '怨念']
]

/**
 * 万象表情，数组标识展示顺序
 *
 */
export const WX_SMILEY = [
  ['001', '开心极了'],
  ['002', '爱你哟'  ],
  ['003', '加油喔'  ],
  ['004', '厉害啦'  ],
  ['005', 'Goodbye' ],
  ['006', '送你花'  ],
  ['007', '羞羞脸'  ],
  ['008', '桑心了'  ],
  ['009', '看我的'  ],
  ['010', '谢谢你'  ],
  ['011', '怎么破'  ],
  ['012', '交给我吧'],
  ['013', '燥起来'  ],
  ['014', '天啦噜'  ],
  ['015', 'OK'      ],
  ['016', '让我瞅瞅'],
  ['017', '么么哒'  ],
  ['018', '灵感来啦'],
  ['019', '给你点赞'],
  ['020', '好好学习'],
  ['021', '拼一拼'  ],
  ['022', '可怜兮兮'],
  ['023', 'Sorry啦' ],
  ['024', '撒花咯'  ]
]


/**
 * 旺旺英文机器人识别表情
 * lazada专用
 */

export const WW_SMILEY_EN = [['001', 'smile_emoji'],
['002', 'shy_emoji'],
['003', 'tongue_emoji'],
['047', 'sadness_emoji'],
['024', 'goodbye_emoji'],
['030', 'confused_emoji'],
['009', 'comfort_emoji'],
['008', 'air_kiss_emoji'],
['023', 'angel_emoji'],
['054', 'goodbye_with_tears_emoji'],
['005', 'love_emoji'],
['011', 'come_on_emoji'],
['040', 'giggle_emoji'],
['036', 'wronged_emoji'],
['048', 'aggrieved_emoji'],
['049', 'sob_emoji'],
['050', 'break_into_tears_emoji'],
['051', 'cry_emoji'],
['053', 'sorry_emoji'],
['070', 'waiter_emoji'],
['069', 'Kung_Hei_Fat_Choi_emoji'],
['067', 'Fortuna_emoji'],
['010', 'hug_emoji'],
['085', 'rose_emoji'],
['087', 'sweetheart_emoji'],
['078', 'beautiful_lady_emoji'],
['079', 'handsome_emoji'],
['012', 'victory_emoji'],
['081', 'deal_emoji'],
['082', 'applaud_emoji'],
['083', 'shake_hands_emoji'],
['031', 'wondering_emoji'],
['042', 'helpless_emoji'],
['013', 'good_emoji'],
['007', 'dancing_emoji'],
['017', 'search_emoji'],
['026', 'enjoying_emoji'],
['004', 'snicker_emoji'],
['021', 'good_idea_emoji'],
['025', 'slobber_emoji'],
['016', 'toothy_laugh_emoji'],
['043', 'sweating_emoji'],
['028', 'transfixed_emoji'],
['055', 'frown_emoji'],
['037', 'shaking_head_emoji'],
['019', 'afterwards_emoji'],
['014', 'kiss_emoji'],
['015', 'anthomaniac_emoji'],
['018', 'calling_emoji'],
['029', 'thinking_emoji'],
['006', 'laughing_emoji'],
['035', 'shhh_emoji'],
['060', 'surprise_emoji'],
['061', 'consternation_emoji'],
['066', 'mad_emoji'],
['071', 'boss_emoji'],
['068', 'learn_from_Lei_Feng_emoji'],
['088', 'heart_breaking_emoji'],
['080', 'Lucky_Cat_emoji'],
['084', 'red_lips_emoji'],
['094', 'cheers_emoji'],
['089', 'money_emoji'],
['097', 'too_late_emoji'],
['091', 'gift_emoji'],
['090', 'shopping_emoji'],
['096', 'waiting_emoji'],
['095', 'clock_emoji'],];

/**
 ** 旺旺英文机器人识别表情，小二不可使用的表情
 * lazada专用
 */

export const WW_BLACKLIST_EN = [ ['020', 'miser_emoji'],
['022', 'grimace_emoji'],
['027', 'erotic_emoji'],
['032', 'no_money_emoji'],
['033', 'boring_emoji'],
['034', 'doubt_emoji'],
['038', 'cold_emoji'],
['039', 'awkward_emoji'],
['041', 'no_way_emoji'],
['044', 'desolate_emoji'],
['045', 'sleepy_emoji'],
['046', 'gosh_emoji'],
['052', 'I_give_up_emoji'],
['056', 'too_tired_emoji'],
['058', 'threw_up_emoji'],
['059', 'recite_emoji'],
['062', 'shut_up_emoji'],
['063', 'owe_flat_emoji'],
['064', 'despise_you_emoji'],
['065', 'furious_emoji'],
['072', 'evil_emoji'],
['073', 'solo_emoji'],
['074', 'CS_emoji'],
['075', 'invisible_man_emoji'],
['076', 'bomb_emoji'],
['077', 'screaming_emoji'],
['086', 'residual_flowers_emoji'],
['092', 'email_emoji'],
['093', 'phone_call_emoji'],
['098', 'airplane_emoji'],
['099', 'Alipay_emoji'],];


// WEBPACK FOOTER //
// ./node_modules/_@ali_tarzan-smiley@0.0.11@@ali/tarzan-smiley/src/map.js